import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, CircularProgress } from "@material-ui/core";
import Button from "./Button";

export default function DeleteConfirmModal({ open, onClose, onConfirm, loading, message }) {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle>Confirmar exclusão</DialogTitle>

            <DialogContent>
                <p style={{ margin: 0, fontSize: "14px", color: "var(--gray-7)" }}>
                    {message || "Deseja remover este registro?"}
                </p>
            </DialogContent>

            <DialogActions style={{ padding: "16px" }}>
                <Button
                    type="button"
                    variant="default"
                    outlined
                    size="md"
                    disabled={loading}
                    onClick={onClose}
                >
                    Cancelar
                </Button>

                <Button
                    type="button"
                    variant="danger"
                    size="md"
                    disabled={loading}
                    onClick={onConfirm}
                >
                    {loading ? <CircularProgress size={16} color="inherit" /> : "Excluir"}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
